import { immerable } from "immer";
import FileData2D from "./file-data-2d.ts";
import FileData3D from "./file-data-3d.ts";
import FileType from "@/models/enums/file-type.ts";
import BaseFileData from "./base-file-data.ts";
import KnownScaleContent from "./known-scale-content.ts";
import UserDefinedContent from "./user-defined-content.ts";

class ContainsFiles {
    [immerable] = true;

    files2d: FileData2D[] = [];

    files3d: FileData3D[] = [];

    public addFile(fileType: FileType, fileId: string, fileName: string, revision: number, filePath: string, fileMetaObject: string, content?: KnownScaleContent | UserDefinedContent | undefined) {
        const array = this.getFilesByType(fileType);
        array.push(new BaseFileData(fileId, fileName, fileType, revision, filePath, fileMetaObject, content));
    }

    public removeFile(fileType: FileType, fileId: string) {
        const array = this.getFilesByType(fileType);

        const i = array.findIndex(f => f.id === fileId);
        if (i >= 0) array.splice(i, 1);
    }

    public containsFile(fileType: FileType, fileName: string) {
        const array = this.getFilesByType(fileType);
        return array.some(f => f.name === fileName);
    }

    public getFile(fileType: FileType, fileId: string) {
        const array = this.getFilesByType(fileType);
        return array.find(f => f.id === fileId);
    }

    public getFilesByType(fileType: FileType) {
        switch (fileType) {
            case FileType.File2D:
                return this.files2d;
            case FileType.File3D:
            case FileType.File3DFrom2D:
                return this.files3d;
            default:
                throw new Error(`Unknown file type: ${fileType}`);
        }
    }
}

export default ContainsFiles;